import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';

import HeSigninTemplate from '../components/common/template/HeSigninTemplate';
import { useSignIn } from '../Hooks/useAuth';
import * as PATH from '../lib/routes/path';

const HeSigninPage = () => {
  const {
    state,
    inputRef,
    logged,
    isLoading,
    isValidateTrue,
    onChangeValue,
    onSignin,
  } = useSignIn();

  return logged ? (
    <Redirect to={`${PATH.HE_RESULTS}/${sessionStorage.getItem('be_id')}`} />
  ) : (
    <HeSigninTemplate
      state={state}
      onChangeValue={onChangeValue}
      onSignin={onSignin}
      isValidateTrue={isValidateTrue}
      isLoading={isLoading}
      signInRef={inputRef}
    />
  );
};

export default HeSigninPage;
